import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/src/app/[lang]/blog/[id]/not-found.tsx");
